import React, { useState, useEffect } from 'react';
import api from '../services/api';

function Profiles() {
  const [botProperties, setBotProperties] = useState([]);
  const [currentBot, setCurrentBot] = useState(null);
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const fetchBots = async () => {
      try {
        const data = await api.get('/scripts/bot-properties');
        setBotProperties(data);
        if (data.length > 0) {
          setCurrentBot(data[0]);
          setContent(data[0].content);
        }
      } catch (err) {
        console.error('Failed to fetch bot properties:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchBots();
  }, []);

  const handleSelectBot = (bot) => {
    setCurrentBot(bot);
    setContent(bot.content);
  };

  const handleSave = async () => {
    if (!currentBot) return;
    setSaving(true);
    setMessage(null);
    try {
      await api.put(`/scripts/${currentBot.path}`, { content });
      setMessage({ type: 'success', text: 'Bot profile saved successfully!' });
    } catch (err) {
      setMessage({ type: 'error', text: 'Failed to save bot profile.' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="card">Loading profiles...</div>;

  return (
    <div>
      <div className="page-header">
        <h2>Bot Profiles</h2>
        <p>Manage bot property configurations for different characters</p>
      </div>

      {message && (
        <div className={`alert alert-${message.type}`}>{message.text}</div>
      )}

      <div className="two-col">
        <div className="card">
          <div className="card-title">Saved Profiles</div>
          <div className="script-tree">
            {botProperties.map((bot, idx) => (
              <div
                key={idx}
                className={`tree-item file ${currentBot?.name === bot.name ? 'active' : ''}`}
                onClick={() => handleSelectBot(bot)}
              >
                🤖 {bot.name}
              </div>
            ))}
          </div>
        </div>

        <div className="card">
          <div className="card-title">
            {currentBot ? `Editing: ${currentBot.name}` : 'No profile selected'}
          </div>
          {currentBot && (
            <>
              <div className="form-group">
                <textarea
                  value={content}
                  onChange={e => setContent(e.target.value)}
                  spellCheck={false}
                />
              </div>
              <div className="btn-group">
                <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
                  {saving ? 'Saving...' : 'Save Profile'}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Profiles;
